export class NotInitializedException extends Error {
  constructor(message?: string) {
    super(message)

    Object.setPrototypeOf(this, NotInitializedException.prototype)
  }
}

export default NotInitializedException
